import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { createCrud, useAxiosClient, useMutation } from '@lumahealthhq/ui-model';
import { getModelBasePath } from '@lumahealthhq/ui-utils';
var basePath = getModelBasePath('broadcastTemplate');
var crud = createCrud(basePath);

/* Default queries */
export var useBroadcastTemplateCount = crud.makeCount();
export var useBroadcastTemplateById = crud.makeFindById();
export var useBroadcastTemplateByIds = crud.makeFindByIds();
export var useBroadcastTemplateMany = crud.makeFindMany();
export var useBroadcastTemplateOne = crud.makeFindOne();
export var useBroadcastTemplatePagination = crud.makePagination();

/* Default mutations */
export var useBroadcastTemplateCreateOne = crud.makeCreateOne();
export var useBroadcastTemplateUpdateOne = crud.makeUpdateOne();
export var useBroadcastTemplateRemoveById = crud.makeRemoveById();

/* Custom queries */
export function useBroadcastTemplateDuplicateOne() {
  var axiosClient = useAxiosClient();
  var mutationFn = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(id) {
      var _yield$axiosClient$po, data;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return axiosClient.post("v2/".concat(basePath, "/").concat(id, "/duplicate"));
          case 2:
            _yield$axiosClient$po = _context.sent;
            data = _yield$axiosClient$po.data;
            return _context.abrupt("return", data);
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function mutationFn(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  var mutationResult = useMutation([basePath], mutationFn);
  return mutationResult;
}